module.exports = __webpack_public_path__ + "img/Picture23.bde6c8a7.png";